/* This is just a static page to display when no conversation is selected. */
import React from 'react';
import { APP_NAME, LINK_DOMAIN } from '../config.js';
import logo from '../img/chat/mocha.svg';

export default class LogoView extends React.PureComponent {
  render() {
    const version = APP_NAME;
    return (
      <div id="dummy-view">
        <div>
          <a>
            <img id="logo" alt="logo" src={logo} />
          </a>
        </div>
      </div>
    );
  }
};
